module.exports = __webpack_public_path__ + "assets/images/34KjmdGX.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/wopi-puzzle.png
// module id = 164
// module chunks = 0